import { theme } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const StyledTableBody = styled.tbody`
  tr {
    display: flex;
    flex-direction: column;
    border: 2px solid ${({theme}) => theme.colors.primaryK10};
    border-radius: 0.4rem;

    ${mediaQuery('md')} {
      display: table-row !important;
      border: 0;
      border-radius: 0;
      border-bottom: 1px solid ${({theme}) => theme.colors.primaryK3};
    }
  }

  td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: right;
    line-height: normal;
    color: ${({theme}) => theme.colors.primaryK10};
    ${mediaQuery('md')} {
      display: table-cell;
      text-align: left;
    }
  }

  td::before {
    content: attr(data-label);
    font-weight: ${theme.fontWeight.bold};
    font-size: var(--h5-font-size);
    line-height: var(--h5-line-height);
    color: ${({theme}) => theme.colors.primaryK7};
    text-transform: uppercase;
    text-align: left;

    ${mediaQuery('md')} {
      display: none;
    }
  }
`;
